export const GET_FACULTIES = "GET_FACULTIES"
export const GET_FACULTIES_FAIL = "GET_FACULTIES_FAIL"
export const GET_FACULTIES_SUCCESS = "GET_FACULTIES_SUCCESS"

export const ADD_NEW_FACULTY = "ADD_NEW_FACULTY"
export const ADD_FACULTY_SUCCESS = "ADD_FACULTY_SUCCESS"
export const ADD_FACULTY_FAIL = "ADD_FACULTY_FAIL"

export const UPDATE_FACULTY = "UPDATE_FACULTY"
export const UPDATE_FACULTY_SUCCESS = "UPDATE_FACULTY_SUCCESS"
export const UPDATE_FACULTY_FAIL = "UPDATE_FACULTY_FAIL"

export const DELETE_FACULTY = "DELETE_FACULTY"
export const DELETE_FACULTY_SUCCESS = "DELETE_FACULTY_SUCCESS"
export const DELETE_FACULTY_FAIL = "DELETE_FACULTY_FAIL"





